import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import axios from 'axios';

const ResetPassword = () => {
  const [formData, setFormData] = useState({
    password: '',
    confirmPassword: ''
  });
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  
  const navigate = useNavigate();
  const location = useLocation();
  const { password, confirmPassword } = formData;

  // Verificar si el usuario ha sido verificado correctamente
  useEffect(() => {
    const userEmail = location.state?.email;
    const verified = location.state?.verified;
    
    if (!userEmail || !verified) {
      // Si no está verificado, redirigir a la página de recuperación de contraseña
      navigate('/forgot-password');
    } else {
      setEmail(userEmail);
    }
  }, [location.state, navigate]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    // Validar formulario
    if (!password || !confirmPassword) {
      setError('Por favor complete todos los campos');
      return;
    }

    if (password !== confirmPassword) {
      setError('Las contraseñas no coinciden');
      return;
    }

    // Validación de contraseña robusta
    if (password.length < 8 || password.length > 17) {
      setError('La contraseña debe tener entre 8 y 17 caracteres');
      return;
    }
    
    // Validar que contenga al menos un número
    if (!/\d/.test(password)) {
      setError('La contraseña debe contener al menos un número');
      return;
    }
    
    // Validar que contenga al menos una minúscula
    if (!/[a-z]/.test(password)) {
      setError('La contraseña debe contener al menos una letra minúscula');
      return;
    }
    
    // Validar que contenga al menos una mayúscula
    if (!/[A-Z]/.test(password)) {
      setError('La contraseña debe contener al menos una letra mayúscula');
      return;
    }
    
    setLoading(true);
    
    try {
      // Enviar solicitud para restablecer la contraseña
      await axios.post('/api/auth/reset-password', {
        email,
        password
      });
      
      // Mostrar mensaje de éxito
      setSuccess(true);
      
      // Redirigir al login después de 3 segundos
      setTimeout(() => {
        navigate('/login', { 
          state: { 
            passwordReset: true,
            message: 'Contraseña restablecida exitosamente. Por favor inicie sesión con su nueva contraseña.'
          } 
        });
      }, 3000);
      
    } catch (err) {
      setError(err.response?.data?.error || 'Error al restablecer la contraseña. Por favor intente nuevamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-form-container">
        <div className="auth-header">
          <h2>Establecer Nueva Contraseña</h2>
          <p>Cree una nueva contraseña para su cuenta</p>
        </div>
        
        {error && (
          <div className="error-message">
            <i className="fas fa-exclamation-circle"></i> {error}
          </div>
        )}
        
        {success && (
          <div className="success-message">
            <i className="fas fa-check-circle"></i> Contraseña restablecida exitosamente. Redirigiendo al inicio de sesión...
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="password">Nueva Contraseña</label>
            <div className="input-with-icon">
              <i className="fas fa-lock input-icon"></i>
              <input
                id="password"
                type="password"
                name="password"
                value={password}
                onChange={handleChange}
                disabled={loading || success}
                placeholder="Ingrese su nueva contraseña"
                required
                onInvalid={(e) => e.target.setCustomValidity('Por favor ingrese una contraseña')}
                onInput={(e) => e.target.setCustomValidity('')}
                autoComplete="new-password"
              />
            </div>
            <div className="password-requirements">
              <small>
                La contraseña debe tener:
                <ul>
                  <li>Entre 8 y 17 caracteres</li>
                  <li>Al menos un número</li>
                  <li>Al menos una letra minúscula</li>
                  <li>Al menos una letra mayúscula</li>
                </ul>
              </small>
            </div>
          </div>
          
          <div className="form-group">
            <label htmlFor="confirmPassword">Confirmar Contraseña</label>
            <div className="input-with-icon">
              <i className="fas fa-lock input-icon"></i>
              <input
                id="confirmPassword"
                type="password"
                name="confirmPassword"
                value={confirmPassword}
                onChange={handleChange}
                disabled={loading || success}
                placeholder="Confirme su nueva contraseña"
                required
                onInvalid={(e) => e.target.setCustomValidity('Por favor confirme su contraseña')}
                onInput={(e) => e.target.setCustomValidity('')}
                autoComplete="new-password"
              />
            </div>
          </div>
          
          <button 
            type="submit" 
            className="btn-primary" 
            disabled={loading || success}
          >
            {loading ? (
              <>
                <span className="spinner"></span> Guardando...
              </>
            ) : (
              'Guardar Contraseña'
            )}
          </button>
        </form>
        
        <div className="auth-footer">
          <p>
            <Link to="/login">Volver al inicio de sesión</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
